import React, { useState, useEffect, useCallback, useRef } from "react";
import "../../App.css";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { Button, Box, Typography, Menu, MenuItem } from "@material-ui/core";
import CustomCheckbox from "../../components/checkboxRenderer";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { LicenseManager } from "ag-grid-enterprise";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import fnOpenToast from "../../components/toast";
import { Link as ReactLink } from "react-router-dom";
import AddSpecialPlateDialog from "../../components/addSpecialPlateDialog";
import EditIcon from "@material-ui/icons/Edit";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import RedoIcon from "@material-ui/icons/Redo";
import { notifyError } from "../../utils/toast";
import {
    getSpecialPlates,
    createSpecialPlate,
    updateSpecialPlates,
} from "../../api";

toast.configure();
LicenseManager.setLicenseKey(
    "Using_this_{AG_Grid}_Enterprise_key_{AG-062453}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Lucid_USA,_Inc}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{V360}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{V360}_need_to_be_licensed___{V360}_has_been_granted_a_Deployment_License_Add-on_for_{2}_Production_Environments___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{28_August_2025}____[v3]_[01]_MTc1NjMzNTYwMDAwMA==83cd4edac4587e17c3187cf63f89d914",
);

const initialValue = {
    type: {
        value: "",
        hasError: false,
    },
    country: {
        value: "",
        hasError: false,
    },
    state: {
        value: "",
        hasError: false,
    },
    renewalAndReassignmentAmount: {
        value: null,
        hasError: false,
    },
    renewalAndReassignmentPersonalized: {
        value: null,
        hasError: false,
    },
    renewalAndReassignmentSequential: {
        value: null,
        hasError: false,
    },
    reassignmentAmount: {
        value: null,
        hasError: false,
    },
    reassignmentPersonalized: {
        value: null,
        hasError: false,
    },
    reassignmentSequential: {
        value: null,
        hasError: false,
    },
    isActive: {
        value: true,
        hasError: false,
    },
};

function SpecialPlateFees() {
    const gridRef = useRef();
    const [gridApi, setGridApi] = useState(null);
    const [actionsAnchorEl, setActionsAnchorEl] = useState(null);
    const [statesAnchorEl, setStatesAnchorEl] = useState(null);
    const [tableData, setTableData] = useState([]);
    const [open, setOpen] = React.useState(false);
    const [formData, setFormData] = useState(initialValue);
    const [enableEditing, setEnableEditing] = useState(false);
    const [rowsUpdated, setRowsUpdated] = useState(new Map());

    const frameworkComponents = {
        checkboxRenderer: CustomCheckbox,
    };

    const columnDefs = [
        {
            headerName: "Type",
            field: "type",
            flex: 2,
        },
        {
            headerName: "Renewal & Reassignment",
            children: [
                {
                    headerName: "Amount",
                    field: "renewalAndReassignmentAmount",
                    cellDataType: "number",
                    cellEditorParams: {
                        preventStepping: true,
                    },
                    valueSetter: (params) => {
                        if (params.newValue < 0) {
                            alert("The value cannot be negative.");
                            return false;
                        }
                        params.data[params.colDef.field] = params.newValue;
                        return true;
                    },
                },
                {
                    headerName: "Sequential Amount",
                    field: "renewalAndReassignmentSequential",
                    cellDataType: "number",
                    cellEditor: "agNumberCellEditor",
                    cellEditorParams: {
                        preventStepping: true,
                    },
                    valueSetter: (params) => {
                        if (params.newValue < 0) {
                            alert("The value cannot be negative.");
                            return false;
                        }
                        params.data[params.colDef.field] = params.newValue;
                        return true;
                    },
                },
                {
                    headerName: "Personalized Amount",
                    field: "renewalAndReassignmentPersonalized",
                    cellDataType: "number",
                    cellEditorParams: {
                        preventStepping: true,
                    },
                    valueSetter: (params) => {
                        if (params.newValue < 0) {
                            alert("The value cannot be negative.");
                            return false;
                        }
                        params.data[params.colDef.field] = params.newValue;
                        return true;
                    },
                },
            ],
            flex: 2,
        },
        {
            headerName: "Reassignment",
            children: [
                {
                    headerName: "Amount",
                    field: "reassignmentAmount",
                    cellDataType: "number",
                    cellEditorParams: {
                        preventStepping: true,
                    },
                    valueSetter: (params) => {
                        if (params.newValue < 0) {
                            alert("The value cannot be negative.");
                            return false;
                        }
                        params.data[params.colDef.field] = params.newValue;
                        return true;
                    },
                },
                {
                    headerName: "Sequential Amount",
                    field: "reassignmentSequential",
                    cellDataType: "number",
                    cellEditor: "agNumberCellEditor",
                    cellEditorParams: {
                        preventStepping: true,
                    },
                    valueSetter: (params) => {
                        if (params.newValue < 0) {
                            alert("The value cannot be negative.");
                            return false;
                        }
                        params.data[params.colDef.field] = params.newValue;
                        return true;
                    },
                },
                {
                    headerName: "Personalized Amount",
                    field: "reassignmentPersonalized",
                    cellDataType: "number",
                    cellEditorParams: {
                        preventStepping: true,
                    },
                    valueSetter: (params) => {
                        if (params.newValue < 0) {
                            alert("The value cannot be negative.");
                            return false;
                        }
                        params.data[params.colDef.field] = params.newValue;
                        return true;
                    },
                },
            ],
            flex: 2,
        },
        {
            headerName: "Active",
            field: "isActive",
            cellRenderer: "checkboxRenderer",
            flex: 1,
        },
    ];

    const defaultColDef = {
        sortable: true,
        filter: true,
        floatingFilter: true,
        editable: enableEditing,
        resizable: true,
    };

    useEffect(() => {
        getData();
    }, []);

    const onChange = (e) => {
        const { value, id, name } = e.target;
        setFormData({
            ...formData,
            [id ?? name]: { value: value, hasError: false },
        });
    };

    const onGridReady = (params) => {
        setGridApi(params);
    };

    const getData = async () => {
        const specialPlates = await getSpecialPlates();
        const formattedResponse = specialPlates.map((r) => ({
            ...r,
            renewalAndReassignmentAmount: Number.isFinite(
                r?.renewalAndReassignment?.amount,
            )
                ? r?.renewalAndReassignment?.amount
                : null,
            reassignmentAmount: Number.isFinite(r?.reassignment?.amount)
                ? r?.reassignment?.amount
                : null,
            renewalAndReassignmentSequential: Number.isFinite(
                r?.renewalAndReassignment?.sequential,
            )
                ? r?.renewalAndReassignment?.sequential
                : null,
            renewalAndReassignmentPersonalized: Number.isFinite(
                r?.renewalAndReassignment?.personalized,
            )
                ? r?.renewalAndReassignment?.personalized
                : null,
            reassignmentSequential: Number.isFinite(r?.reassignment?.sequential)
                ? r?.reassignment?.sequential
                : null,
            reassignmentPersonalized: Number.isFinite(
                r?.reassignment?.personalized,
            )
                ? r?.reassignment?.personalized
                : null,
        }));
        setTableData(formattedResponse);
    };

    const handleStatesClick = useCallback((event) => {
        setStatesAnchorEl(event.currentTarget);
    }, []);

    const handleStatesClose = useCallback(() => {
        setStatesAnchorEl(null);
    }, []);

    const handleActionClick = useCallback((event) => {
        setActionsAnchorEl(event.currentTarget);
    }, []);

    const handleActionClose = useCallback(() => {
        setActionsAnchorEl(null);
    }, []);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setFormData(initialValue);
    };

    const handleFormSubmit = async (event) => {
        try {
            event.preventDefault();
            const request = constructRequest(formData);
            await createSpecialPlate(request);
            handleClose();
            getData();
            fnOpenToast(
                "Special Plate Fee Added Successfully. This change will only apply to CFS. If a new picklist value is needed in SFDC for this change, please ensure you submit a ticket",
                "success",
            );
        } catch (error) {
            notifyError(error.message);
        }
    };

    const handleCancelEdit = () => {
        setEnableEditing(false);
        setRowsUpdated(new Map());
        getData();
    };

    const handleUpdate = async (editedRows) => {
        for (const row of editedRows) {
            if (
                !Number.isFinite(row?.renewalAndReassignmentAmount) &&
                [
                    row?.renewalAndReassignmentPersonalized,
                    row?.renewalAndReassignmentSequential,
                ].some((e) => !Number.isFinite(e))
            ) {
                fnOpenToast(
                    "You must specify all personalized and sequential values when amount is not specified",
                    "error",
                );
                return;
            }

            if (
                Number.isFinite(row?.renewalAndReassignmentAmount) &&
                [
                    row?.renewalAndReassignmentPersonalized,
                    row?.renewalAndReassignmentSequential,
                ].some((e) => e !== null && Number.isFinite(e))
            ) {
                fnOpenToast(
                    "If you specify an amount, all personalized and sequential values must to be empty",
                    "error",
                );
                return;
            }

            if (
                !Number.isFinite(row?.reassignmentAmount) &&
                [
                    row?.reassignmentPersonalized,
                    row?.reassignmentSequential,
                ].some((e) => !Number.isFinite(e))
            ) {
                fnOpenToast(
                    "You must specify all personalized and sequential values when amount is not specified",
                    "error",
                );
                return;
            }

            if (
                Number.isFinite(row?.reassignmentAmount) &&
                [
                    row?.reassignmentPersonalized,
                    row?.reassignmentSequential,
                ].some((e) => e !== null && Number.isFinite(e))
            ) {
                fnOpenToast(
                    "If you specify an amount, all personalized and sequential values must to be empty",
                    "error",
                );
                return;
            }

            if (!row.type) {
                fnOpenToast("Type is required", "error");
                return;
            }
        }

        const updateRequest = {
            updateSpecialPlate: editedRows.map((row) => ({
                ...row,
                renewalAndReassignment: {
                    amount: Number.isFinite(row.renewalAndReassignmentAmount)
                        ? +row.renewalAndReassignmentAmount
                        : null,
                    sequential: Number.isFinite(
                        row.renewalAndReassignmentAmount,
                    )
                        ? null
                        : +row.renewalAndReassignmentSequential,
                    personalized: Number.isFinite(
                        row.renewalAndReassignmentAmount,
                    )
                        ? null
                        : +row.renewalAndReassignmentPersonalized,
                },
                reassignment: {
                    amount: Number.isFinite(row.reassignmentAmount)
                        ? +row.reassignmentAmount
                        : null,
                    sequential: Number.isFinite(row.reassignmentAmount)
                        ? null
                        : +row.reassignmentSequential,
                    personalized: Number.isFinite(row.reassignmentAmount)
                        ? null
                        : +row.reassignmentPersonalized,
                },
            })),
        };

        const confirm = window.confirm(
            "Are you sure, you want to update this row ?",
        );
        if (!confirm) {
            return;
        }

        try {
            setEnableEditing(false);
            await updateSpecialPlates(updateRequest);
            fnOpenToast("Special Plate Fee Modified Successfully", "success");
            getData();
        } catch (error) {
            notifyError(error.message);
        }
    };

    const handleSaveEdited = () => {
        const editedRows = Array.from(rowsUpdated.values());
        handleUpdate(editedRows);
        setRowsUpdated(new Map());
    };

    const handleCellValueChanged = (event) =>
        setRowsUpdated(rowsUpdated.set(event?.data?._id, event?.data));

    const handleEnableEditing = () => {
        setEnableEditing(true);
    };

    const constructRequest = (formData) => {
        const request = {
            type: formData.type.value,
            //TODO: sending these values for now but we need to support other countries/states in a future
            country: "US",
            state: "CA",
            isActive: formData.isActive.value,
            renewalAndReassignment: {
                amount:
                    formData.renewalAndReassignmentAmount.value !== null &&
                    formData.renewalAndReassignmentAmount.value !== ""
                        ? +formData.renewalAndReassignmentAmount.value
                        : null,
                personalized:
                    formData.renewalAndReassignmentAmount.value !== null &&
                    formData.renewalAndReassignmentAmount.value !== ""
                        ? null
                        : +formData.renewalAndReassignmentPersonalized.value,
                sequential:
                    formData.renewalAndReassignmentAmount.value !== null &&
                    formData.renewalAndReassignmentAmount.value !== ""
                        ? null
                        : +formData.renewalAndReassignmentSequential.value,
            },
            reassignment: {
                amount:
                    formData.reassignmentAmount.value !== null &&
                    formData.reassignmentAmount.value !== ""
                        ? +formData.reassignmentAmount.value
                        : null,
                personalized:
                    formData.reassignmentAmount.value !== null &&
                    formData.reassignmentAmount.value !== ""
                        ? null
                        : +formData.reassignmentPersonalized.value,
                sequential:
                    formData.reassignmentAmount.value !== null &&
                    formData.reassignmentAmount.value !== ""
                        ? null
                        : +formData.reassignmentSequential.value,
            },
        };

        return request;
    };

    return (
        <>
            <div>
                <div style={{ margin: "10px 20px" }}>
                    <Breadcrumbs aria-label="breadcrumb">
                        <ReactLink
                            color="inherit"
                            to="/"
                            className="breadcrumb-link"
                        >
                            Dashboard
                        </ReactLink>
                        <ReactLink
                            color="inherit"
                            to="/vehiclesalesfees/US"
                            className="breadcrumb-link"
                        >
                            Fee Administration
                        </ReactLink>
                        <Typography color="textPrimary">
                            Special Plate Fees - California
                        </Typography>
                    </Breadcrumbs>
                </div>
                <Box
                    display="flex"
                    justifyContent="space-between"
                    style={{ margin: "10px 20px" }}
                >
                    <div>
                        <Typography
                            variant="h5"
                            component={"h5"}
                            style={{
                                fontFamily: "GTAmericaMedium",
                                fontSize: "24px",
                                lineHeight: "120%",
                                fontWeight: "500",
                            }}
                        >
                            Special Plate Fees - California
                        </Typography>
                    </div>
                    <div style={{ display: "flex" }}>
                        <Box
                            display="flex"
                            justifyContent="space-between"
                            alignItems="center"
                        >
                            <Button
                                style={{ marginRight: "10px" }}
                                variant="outlined"
                                color="primary"
                                aria-controls="action-menu"
                                aria-haspopup="true"
                                onClick={handleStatesClick}
                            >
                                State <ExpandMoreIcon />
                            </Button>
                            <Menu
                                id="action-menu"
                                anchorEl={statesAnchorEl}
                                keepMounted
                                open={Boolean(statesAnchorEl)}
                                onClose={handleStatesClose}
                            >
                                {/* TODO: support other states */}
                                <MenuItem>CA</MenuItem>
                            </Menu>
                        </Box>
                        <Box
                            display="flex"
                            justifyContent="space-between"
                            alignItems="center"
                        >
                            <Button
                                variant="outlined"
                                color="primary"
                                aria-controls="action-menu"
                                aria-haspopup="true"
                                onClick={handleActionClick}
                            >
                                Actions <ExpandMoreIcon />
                            </Button>
                            <Menu
                                id="action-menu"
                                anchorEl={actionsAnchorEl}
                                keepMounted
                                open={Boolean(actionsAnchorEl)}
                                onClose={handleActionClose}
                            >
                                <MenuItem onClick={handleClickOpen}>
                                    <AddCircleOutlineIcon
                                        fontSize="small"
                                        style={{ marginRight: "5px" }}
                                    />{" "}
                                    Add Special Plate
                                </MenuItem>
                                <MenuItem onClick={handleEnableEditing}>
                                    <EditIcon
                                        fontSize="small"
                                        style={{ marginRight: "5px" }}
                                    />{" "}
                                    Enable Editing
                                </MenuItem>
                                <MenuItem onClick={handleSaveEdited}>
                                    <CheckCircleOutlineIcon
                                        fontSize="small"
                                        style={{ marginRight: "5px" }}
                                    />{" "}
                                    Save Changes
                                </MenuItem>
                                <MenuItem
                                    onClick={handleCancelEdit}
                                    disabled={!enableEditing}
                                >
                                    <RedoIcon
                                        fontSize="small"
                                        style={{ marginRight: "5px" }}
                                    />{" "}
                                    Cancel Changes
                                </MenuItem>
                            </Menu>
                        </Box>
                    </div>
                </Box>
                <table
                    style={{
                        margin: "0 20px",
                        width: "calc(100% - 40px)",
                        height: "calc(100vh - 170px)",
                    }}
                >
                    <tbody>
                        <tr>
                            <td style={{ border: "1px solid #babfc7" }}>
                                <div
                                    className="ag-theme-alpine"
                                    style={{
                                        height: "100%",
                                        width: "100%",
                                    }}
                                >
                                    <AgGridReact
                                        rowData={tableData}
                                        columnDefs={columnDefs}
                                        defaultColDef={defaultColDef}
                                        onGridReady={onGridReady}
                                        ref={gridRef}
                                        onCellValueChanged={
                                            handleCellValueChanged
                                        }
                                        enableCellChangeFlash={true}
                                        frameworkComponents={
                                            frameworkComponents
                                        }
                                    />
                                </div>
                                <AddSpecialPlateDialog
                                    open={open}
                                    handleClose={handleClose}
                                    data={formData}
                                    onChange={onChange}
                                    handleFormSubmit={handleFormSubmit}
                                />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </>
    );
}

export default SpecialPlateFees;
